import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../../../../contexts/LanguageContext";
import { translations } from "../../../../translations";
import logo from "../../../../assets/logo.png";
import mcgillLogo from "../../../../assets/Mcgill.png";
import vanierLogo from "../../../../assets/Vanier.png";
import uqamLogo from "../../../../assets/UQAM.jpg";
import googleLogo from "../../../../assets/Google.png";

const Hero = () => {
  const navigate = useNavigate();
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  const scrollToContact = () => {
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      const headerOffset = 80;
      const elementPosition = contactSection.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const handleLogoClick = () => {
    navigate("/login");
  };

  return (
    <section className="hero-section">
      <div className="hero-content">
        <div
          className="hero-logo-container"
          onClick={handleLogoClick}
          style={{ cursor: "pointer" }}
        >
          <img src={logo} alt="SocratesLab Logo" className="hero-logo" />
        </div>
        <h1>{t.hero.title}</h1>
        <p className="tagline">{t.hero.tagline}</p>
        <div className="hero-buttons">
          <button className="primary-button" onClick={() => navigate("/login")}>
            {t.hero.getStarted}
          </button>
          <button className="secondary-button" onClick={scrollToContact}>
            {t.hero.tryDemo}
          </button>
        </div>

        {/* Temporarily commented out pricing section
        <div className="pricing-container">
          <div className="pricing-plan">
            <h3>Enterprise</h3>
            <div className="pricing-options">
              <div className="pricing-option">
                <h4>Base LMS</h4>
                <p className="pricing-price enterprise-price">Contact Us!</p>
                <ul className="pricing-features">
                  <li>Unlimited courses</li>
                  <li>Custom branding</li>
                  <li>Advanced analytics</li>
                  <li>API integration</li>
                </ul>
                <button
                  className="pricing-button pricing-button-contact"
                  onClick={scrollToContact}
                >
                  Get a Quote
                </button>
              </div>
              <div className="pricing-option">
                <h4>AI-enabled</h4>
                <p className="pricing-price enterprise-price">Contact Us!</p>
                <ul className="pricing-features">
                  <li>All Base LMS features</li>
                  <li>AI-powered feedback</li>
                  <li>Smart content generation</li>
                </ul>
                <button
                  className="pricing-button pricing-button-contact"
                  onClick={scrollToContact}
                >
                  Get a Quote
                </button>
              </div>
            </div>
          </div>

          <div className="pricing-plan">
            <h3>Individual</h3>
            <div className="pricing-options">
              <div className="pricing-option">
                <h4>Teacher</h4>
                <p className="pricing-price individual-price">Contact Us!</p>
                <ul className="pricing-features">
                  <li>Up to 5 courses</li>
                  <li>Maximum 150 students</li>
                  <li>Advanced analytics</li>
                  <li>Email support</li>
                </ul>
                <button
                  className="pricing-button pricing-button-signup"
                  onClick={scrollToContact}
                >
                  Sign Up Now
                </button>
              </div>
              <div className="pricing-option">
                <h4>Student</h4>
                <p className="pricing-price individual-price">Contact Us!</p>
                <ul className="pricing-features">
                  <li>Access to all enrolled courses</li>
                  <li>Access to Socratic AI</li>
                  <li>Progress tracking</li>
                </ul>
                <button
                  className="pricing-button pricing-button-signup"
                  onClick={scrollToContact}
                >
                  Sign Up Now
                </button>
              </div>
            </div>
          </div>
        </div>
        */}

        {/* University Partners Logo Slider */}
        <div className="university-partners-section">
          <p className="partners-subtitle">
            {t.hero.pilotTesting ||
              "Currently pilot testing with leading institutions"}
          </p>
          <div className="university-logos-container">
            <div className="university-logos-slider">
              <div className="university-logo-item">
                <img
                  src={mcgillLogo}
                  alt="McGill University"
                  className="university-logo"
                />
              </div>
              <div className="university-logo-item">
                <img
                  src={vanierLogo}
                  alt="Vanier College"
                  className="university-logo"
                />
              </div>
              <div className="university-logo-item">
                <img src={uqamLogo} alt="UQAM" className="university-logo" />
              </div>
              <div className="university-logo-item">
                <img
                  src={googleLogo}
                  alt="Google"
                  className="university-logo"
                />
              </div>
              {/* Duplicate logos for seamless scrolling */}
              <div className="university-logo-item">
                <img
                  src={mcgillLogo}
                  alt="McGill University"
                  className="university-logo"
                />
              </div>
              <div className="university-logo-item">
                <img
                  src={vanierLogo}
                  alt="Vanier College"
                  className="university-logo"
                />
              </div>
              <div className="university-logo-item">
                <img src={uqamLogo} alt="UQAM" className="university-logo" />
              </div>
              <div className="university-logo-item">
                <img
                  src={googleLogo}
                  alt="Google"
                  className="university-logo"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
